export const evProject = 'ev-landing';

export const evTrack = 'ev-landing';

export const guideToBuyingEvProject = 'guide-to-buying-ev-landing';

export const guideToBuyingEvTrack = 'guide-to-buying-ev-landing';

export const homeProject = 'home';

export const homeTrack = 'home';

export const semProject = 'sem';

export const semTrack = 'sem';

export const sitePageProject = 'site-page';

export const sitePageTrack = 'site-page';

export const vdpLitePage = 'vdp-lite';

export const vdpStandardPage = 'vdp';

export const vdpTrack = 'vdp';

export const vendingMachinePage = 'vending-machine';

export const vendingMachineTrack = 'vending-machine';

export const whatToExpectProject = 'what-to-expect';

export const whatToExpectTrack = 'what-to-expect';
